import {
  Button,
  DatePickerController,
  InputController,
} from '../../components';
import { useAppDispatch } from '../../storeHook';
import { showAlert } from '../../services/alert';
import * as yup from 'yup';
import { useFormWithSchema } from '../../utils/functions/yupFormTypescript';
import {
  useNavigate,
  useSearchParams,
} from 'react-router-dom';
import { skipToken } from '@reduxjs/toolkit/query';
import { useEffect } from 'react';
import {
  useGetCreditPeriodDetailsQuery,
  useUpdateCreditPeriodMutation,
} from '../../services/creditPeriod';
import dayjs from 'dayjs';

const formSchema = yup.object({
  creditPeriod: yup
    .number()
    .required()
    .typeError('please enter an integer value'),
  expiry: yup
    .date()
    .required('expiry date is required')
    .min(new Date(), 'Date should not be in past'),
});
type TFormData = yup.InferType<typeof formSchema>;

export const EditCreditPeriod: React.FC = () => {
  const navigate = useNavigate();
  const {
    formState: { errors },
    handleSubmit,
    register,
    reset,
    control,
  } = useFormWithSchema(formSchema, {
    mode: 'onTouched',
  });

  const [searchParams] = useSearchParams();
  const dataId = searchParams.get('id');
  const { data: fetchedData } =
    useGetCreditPeriodDetailsQuery(dataId ?? skipToken);
  useEffect(() => {
    if (fetchedData) {
      reset({
        creditPeriod: fetchedData.creditPeriod,
        expiry: new Date(
          fetchedData.expiry.split('-').reverse().join('-')
        ),
      });
    }
  }, [fetchedData]);

  const dispatch = useAppDispatch();
  const [update] = useUpdateCreditPeriodMutation();
  const onUpdateClick = (data: TFormData) => {
    fetchedData &&
      update({
        ...fetchedData,
        ...data,
        expiry: dayjs(data.expiry).format('DD-MM-YYYY'),
      })
        .unwrap()
        .then(() => {
          navigate('/credit-period');
          dispatch(
            showAlert({
              content: 'Credit period updated successfully',
            })
          );
        })
        .catch((err) => {
          console.log('error', err);
          // this.utility.handleError(err);
        });
  };

  return (
    <form
      onSubmit={handleSubmit((data) => onUpdateClick(data))}
      className="grid grid-cols-2 gap-x-10">
      <InputController
        label="Credit Period"
        register={register('creditPeriod')}
        error={errors.creditPeriod?.message}
        required
      />
      <DatePickerController
        label="Expiry"
        control={control}
        name="expiry"
        error={errors.expiry?.message}
        required
      />

      <div className="col-span-full form-control mt-8 flex justify-end">
        <Button
          type="button"
          variant="button--secondary"
          onClick={() => navigate('/credit-period')}>
          Cancel
        </Button>
        <Button className="ml-3" type="submit">
          {dataId ? 'Update' : 'Save'}
        </Button>
      </div>
    </form>
  );
};
